import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import { VISIT_SOURCES } from "./visit-source";

const LogSchema = z.object({
  result: z.enum(["allowed", "denied", "anonymous"]),
  path: z.string().max(500).optional().nullable(),
  lang: z.string().max(10).optional().nullable(),
  userAgent: z.string().max(500).optional().nullable(),
  email: z.string().max(320).optional().nullable(),
  userId: z.string().uuid().optional().nullable(),
  /** Odkud návštěva přišla — aplikace, chat, e-mail nebo referral odkaz. */
  source: z.enum(VISIT_SOURCES).optional().default("app"),
});

export const logMapaAccess = createServerFn({ method: "POST" })
  .inputValidator((data) => LogSchema.parse(data))
  .handler(async ({ data }) => {
    const { supabaseAdmin } = await import("@/integrations/supabase/client.server");
    await supabaseAdmin.from("mapa_access_log").insert({
      result: data.result,
      path: data.path ?? null,
      lang: data.lang ?? null,
      user_agent: data.userAgent ?? null,
      email: data.email ?? null,
      user_id: data.userId ?? null,
      source: data.source,
    });
    return { ok: true as const };
  });
